module.exports = __webpack_public_path__ + "static/img/1-2.590f583.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/1-2.png
// module id = yIwp
// module chunks = 0